import React from 'react';
import { Box, Button, Flex, Text } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';

import { CustomHeading, Title } from 'shared-components';

interface IProps {
  children: React.ReactNode;
  section: string;
  subtitle?: React.ReactNode;
  currentStep?: number;
  steps?: number;
  complete?: boolean;
  hideProgress?: boolean;
  onSkip?: () => void;
  onPrevious?: () => void;
  onNext: () => void;
  onBackToTaskList?: () => void;
}

const QuestionPage: React.FC<IProps> = props => {
  const { children, subtitle, currentStep, complete, section, onNext, onBackToTaskList } = props;

  const pageTitle = `${section}${currentStep ? `: Step ${currentStep}` : ''}`;

  return (
    <>
      <Title title={pageTitle} />

      {onBackToTaskList && (
        <Button
          onClick={onBackToTaskList}
          leftIcon={<FontAwesomeIcon icon={faArrowLeft} className="utility-icon" />}
          variant={'ghost'}
          ml={-3}
        >
          Back to task list
        </Button>
      )}

      <Box pt={4}>
        <CustomHeading level="h1" mb={6}>
          {pageTitle}
        </CustomHeading>

        {subtitle ? <Text>{subtitle}</Text> : null}

        {children}

        <Flex justifyContent={'end'} mt={8}>
          <Button id="save_and_continue" isDisabled={!complete} onClick={onNext} variant={'solid'} size={'lg'}>
            Save &amp; Continue
          </Button>
        </Flex>
      </Box>
    </>
  );
};

export default QuestionPage;
